import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/IframeAuthProvider'
import { Layout } from './components/Layout'
import { PropalystLayout } from './components/PropalystLayout'
import { LoginPage } from './pages/LoginPage'
import { CallbackPage } from './pages/CallbackPage'
import { DashboardPage } from './pages/DashboardPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { ProjectDetailPage } from './pages/ProjectDetailPage'
import { ResponseViewerPage } from './pages/ResponseViewerPage'
import { VendorsPage } from './pages/VendorsPage'
import { VendorResponseDetailPage } from './pages/VendorResponseDetailPage'
import { EvaluationsPage } from './pages/EvaluationsPage'
import { CommunicationsPage } from './pages/CommunicationsPage'
import { AuditPage } from './pages/AuditPage'
import { TasksPage } from './pages/TasksPage'
import { UsersPage } from './pages/UsersPage'
import { ProfilePage } from './pages/ProfilePage'
import { LoadingSpinner } from './components/ui/LoadingSpinner'
import { AuthGuard } from '@shared/auth/AuthGuard'
import { Agentation } from 'agentation'

function App() {
  const auth = useAuth()

  return (
    <>
    <AuthGuard
      appName="Bid Checker"
      appLogo="/propalyst-logo.svg"
      rolePrefix="bidchecker"
      defaultRedirect="/dashboard"
      auth={auth}
      darwinLoginUrl={import.meta.env.VITE_DARWIN_LOGIN_URL}
      loadingComponent={
        <div className="min-h-screen flex items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
      }
    >
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/callback" element={<CallbackPage />} />

        {/* Protected routes */}
        <Route element={<PropalystLayout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
          <Route path="/projects/:projectId/vendors/:responseId" element={<VendorResponseDetailPage />} />
          <Route path="/responses/:responseId" element={<ResponseViewerPage />} />
        </Route>

        <Route path="/projects" element={<Layout><ProjectsPage /></Layout>} />
        <Route path="/vendors" element={<Layout><VendorsPage /></Layout>} />
        <Route path="/evaluations" element={<Layout><EvaluationsPage /></Layout>} />
        <Route path="/communications" element={<Layout><CommunicationsPage /></Layout>} />
        <Route path="/audit" element={<Layout><AuditPage /></Layout>} />
        <Route path="/tasks" element={<Layout><TasksPage /></Layout>} />
        <Route path="/users" element={<Layout><UsersPage /></Layout>} />
        <Route path="/profile" element={<Layout><ProfilePage /></Layout>} />

        {/* Fallback - redirect to dashboard only if no route matches */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthGuard>
    {import.meta.env.VITE_AGENTATION === 'true' && <Agentation className="agentation-toolbar" />}
    </>
  )
}

export default App